import { z } from 'zod'

import type { ZodInfer } from '@mntn-dev/utility-types'

import { NonEmptyStringSchema } from '../property.models.ts'
import {
  BidIdSchema,
  ProjectIdSchema,
  TeamIdSchema,
} from '../unique-id.models.ts'

/**
 * SurveySubjectIdSchema
 */
export const SurveySubjectIdSchema = z.union([
  BidIdSchema,
  ProjectIdSchema,
  TeamIdSchema,
])

export type SurveySubjectId = ZodInfer<typeof SurveySubjectIdSchema>

export const SurveyFeedbackMaxLength = 4096
export const SurveyFeedbackSchema = NonEmptyStringSchema(
  SurveyFeedbackMaxLength
)
export type SurveyFeedback = ZodInfer<typeof SurveyFeedbackSchema>

export const SurveyRatingMin = 1
export const SurveyRatingMax = 5
export const SurveyRatingSchema = z
  .int()
  .min(SurveyRatingMin)
  .max(SurveyRatingMax)
